import { Image } from "rebass";

export default Image;
